import { motion } from "framer-motion";
import { MaskLine, FadeUp } from "@/components/Reveal";
import { ContactDetails, WaButton } from "@/components/Contact";
import { useLang } from "@/context/LangContext";
import { useStore } from "@/context/StoreContext";

export default function ContactPage() {
  const { t, tr, rtl } = useLang();
  const { settings } = useStore();
  const q = settings?.address?.fr || tr(settings?.address);
  return (
    <main data-testid="contact-page" className="grain relative min-h-screen bg-[#0B0B0C] pt-[72px] text-[#F7F3EB]">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-14 px-5 py-20 sm:px-10 lg:grid-cols-12 lg:gap-10 lg:py-28">
        <div className="lg:col-span-6">
          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }} className="flex items-center gap-4">
            <span className="h-px w-12 bg-[#C6A76A]" />
            <span className="eyebrow">{t("contact_over")}</span>
          </motion.div>
          <h1 className={`font-display mt-8 ${rtl ? "text-5xl leading-[1.5] sm:text-6xl" : "text-5xl leading-[1.02] sm:text-7xl"}`}>
            <MaskLine delay={0.1}>{t("contact_title")}</MaskLine>
          </h1>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#F7F3EB]/75">{t("contact_sub")}</p>
          <div className="mt-12">
            <ContactDetails large />
          </div>
          <WaButton testid="contact-page-whatsapp-btn" className="mt-10 w-full bg-[#C6A76A] !text-[#0B0B0C] sm:w-auto" />
        </div>
        {q && (
          <FadeUp delay={0.2} className="lg:col-span-5 lg:col-start-8">
            <div className="relative aspect-[4/5] overflow-hidden border border-[#C6A76A]/30 bg-[#141011] p-2">
              <div className="pointer-events-none absolute inset-2 z-10 border border-[#C6A76A]/20" />
              <iframe
                title={t("address_label")}
                data-testid="contact-map"
                src={`https://maps.google.com/maps?q=${encodeURIComponent(q)}&z=14&output=embed`}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="h-full w-full [filter:grayscale(1)_invert(0.92)_contrast(0.9)_sepia(0.25)]"
              />
            </div>
            <p className="mt-4 text-center text-xs text-[#F7F3EB]/60">{t("map_note")}</p>
          </FadeUp>
        )}
      </div>
    </main>
  );
}
